<template>
  <component
    ref="boxComp"
    :is="componentLoader"
    :box="box"
    :detailSettingProp="detailSettingProp"
    :disableContextMenu="disableContextMenu"
    :parentTask="parentTask"
    :prms="prms"
    :obj="obj"
    :activeBox="activeBox"
    @box-item-selected="boxItemSelected"
    @on-box-edit="$emit('box-edit', $event)"
    @on-box-delete="$emit('box-delete', $event)"
    @on-task-posted="taskPosted"
    @on-parent-edit-show="parentEditShow"
    @on-attach="$emit('on-attach', $event)"
    @on-detail="$emit('on-detail', $event)"
    @show-edit="$emit('show-edit', $event)"
    @load-box="$emit('load-box', $event)"
    @update-box-count="$emit('update-box-count', $event)"
    @box-loaded="$emit('box-loaded', $event)"
    @on-reload-parent="$emit('on-reload-parent', $event)"
    @on-exam-report="$emit('on-exam-report', $event)"
    @on-exam-report-export="$emit('on-exam-report-export', $event)"
    @on-form-setting="$emit('on-form-setting', $event)"
    @set-fullTask="$emit('set-fullTask', $event)"

    @on-prepare-exam-eesult="$emit('on-prepare-exam-eesult')"
    @on-print-exam-result="$emit('on-print-exam-result')"
  ></component>
</template>

<script>
export default {
  name: "taskBox",
  props: {
    parentTask: {
      type: Object,
      default: () => {}
    },
    box: {
      type: Object,
      default: () => {}
    },
    prms: {
      type: Object,
      default: () => {}
    },
    obj: {
      type: Object,
      default: () => {}
    },
    activeBox: {
      type: Object,
      default: () => {}
    },
    detailSettingProp: {
      type: Object,
      default: () => null
    },
    disableContextMenu: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    // console.log('this.box.otCompName', this.$props.box);
    if (this.$props.box.otCompName) {
      this.loadComponent();
    }
  },
  computed: {
    componentLoader() {
      // console.log('this.box.otCompName', this.box.otCompName);
      return () => import(`@/components/box/${this.box.otCompName}`);
    }
  },
  methods: {
    addItem() {
      this.$refs.boxComp.addItem();
    },
    reInit(e) {
      this.$refs.boxComp.reInit(e);
    },
    parentEditShow() {
      this.$emit("on-parent-edit-show");
    },
    taskPosted(e) {
      this.$emit("on-task-posted", { taskId: e.taskId, boxId: e.boxId });
    },
    taskDeleted(id) {
      //this.$emit("on-task-deleted");
      //console.log("taskDeleted ged helj baina")
      this.$refs.boxComp.taskDeleted(id);
    },
    loadComponent() {
      // this.componentLoader().then(comp => {
      //   console.log(comp);
      // });
      this.componentLoader().then();
    },
    init() {
      this.$emit("on-parent-reload");
    },
    taskAdded() {
      this.$emit("task-added");
    },
    boxItemSelected(e) {
      this.$emit("box-item-selected", { flag: e.flag });
    }
  }
};
</script>
